import React from "react";
import Container from "../components/Layouts/Container";
import JobsWinnipeg from "../components/Jobs/JobsWinnipeg";

const JobsWinnipegPage = () => {
  return (
    <Container>
      <JobsWinnipeg />
    </Container>
  );
};

export default JobsWinnipegPage;
